import { PatientCampaignStateNameType } from '../../metadata/PATIENT_CAMPAIGN_STATE_NAME_CONFIGS';

export enum CampaignType {
  OUTREACH = 'OUTREACH',
}

export enum CampaignGroupName {
  INITIAL_ENGAGEMENT = 'INITIAL_ENGAGEMENT',
}

// TODO(patients team): deprecate and use patient population on patient instead; clickup task #86b0cnj61
export enum PatientPopulation {
  MEDICAID = 'MEDICAID',
  MEDICARE = 'MEDICARE',
  EXCHANGE = 'EXCHANGE',
  DUAL_MEDICAID_MEDICARE = 'DUAL_MEDICAID_MEDICARE',
}

export enum CampaignAgeCategory {
  ADULT = 'ADULT',
  PEDIATRIC = 'PEDIATRIC',
}
export enum Weekday {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}

// List of Weekday Enum values. This cannot be accessed via Object.values(Weekday) or Object.keys(Weekday) because those return the string values and numbers.
export const WEEKDAYS = [
  Weekday.MONDAY,
  Weekday.TUESDAY,
  Weekday.WEDNESDAY,
  Weekday.THURSDAY,
  Weekday.FRIDAY,
  Weekday.SATURDAY,
  Weekday.SUNDAY,
];

// These are all possible time based states for ALL campaigns.
// If a campaign is not eligible for one of these states, we will not set the trickle multiplier
// and potential actions.
export enum EligibleTimeBasedState {
  READY_FOR_OUTREACH = 'READY_FOR_OUTREACH',
  READY_FOR_FIRST_PHONE_QUEUED = 'READY_FOR_FIRST_PHONE_QUEUED',
  FIRST_EMAIL_SENT = 'FIRST_EMAIL_SENT',
  FIRST_EMAIL_NOT_SENT = 'FIRST_EMAIL_NOT_SENT',
  FIRST_SMS_SENT = 'FIRST_SMS_SENT',
  FIRST_SMS_NOT_SENT = 'FIRST_SMS_NOT_SENT',
  FIRST_PHONE_CALLED = 'FIRST_PHONE_CALLED',
  SECOND_PHONE_CALLED = 'SECOND_PHONE_CALLED',
  THIRD_PHONE_CALLED = 'THIRD_PHONE_CALLED',
  FOURTH_PHONE_CALLED = 'FOURTH_PHONE_CALLED',
  CALLBACK_PHONE_SCHEDULED = 'CALLBACK_PHONE_SCHEDULED',
  CALLBACK_PHONE_CALLED = 'CALLBACK_PHONE_CALLED',
  STALE_READY_FOR_OUTREACH = 'STALE_READY_FOR_OUTREACH',
  STALE_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_FIRST_EMAIL_SENT = 'STALE_FIRST_EMAIL_SENT',
  STALE_FIRST_EMAIL_NOT_SENT = 'STALE_FIRST_EMAIL_NOT_SENT',
  STALE_FIRST_SMS_SENT = 'STALE_FIRST_SMS_SENT',
  STALE_FIRST_SMS_NOT_SENT = 'STALE_FIRST_SMS_NOT_SENT',
  STALE_FIRST_PHONE_CALLED = 'STALE_FIRST_PHONE_CALLED',
  STALE_SECOND_PHONE_CALLED = 'STALE_SECOND_PHONE_CALLED',
  STALE_SECOND_EMAIL_SENT = 'STALE_SECOND_EMAIL_SENT',
  STALE_SECOND_EMAIL_NOT_SENT = 'STALE_SECOND_EMAIL_NOT_SENT',
  STALE_THIRD_EMAIL_SENT = 'STALE_THIRD_EMAIL_SENT',
  STALE_THIRD_EMAIL_NOT_SENT = 'STALE_THIRD_EMAIL_NOT_SENT',
  STALE_2_READY_FOR_OUTREACH = 'STALE_2_READY_FOR_OUTREACH',
  STALE_2_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_2_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_2_FIRST_EMAIL_SENT = 'STALE_2_FIRST_EMAIL_SENT',
  STALE_2_FIRST_EMAIL_NOT_SENT = 'STALE_2_FIRST_EMAIL_NOT_SENT',
  STALE_2_FIRST_SMS_SENT = 'STALE_2_FIRST_SMS_SENT',
  STALE_2_FIRST_SMS_NOT_SENT = 'STALE_2_FIRST_SMS_NOT_SENT',
  STALE_2_FIRST_PHONE_CALLED = 'STALE_2_FIRST_PHONE_CALLED',
  STALE_2_SECOND_PHONE_CALLED = 'STALE_2_SECOND_PHONE_CALLED',
  STALE_2_THIRD_PHONE_CALLED = 'STALE_2_THIRD_PHONE_CALLED',
  STALE_2_FOURTH_PHONE_CALLED = 'STALE_2_FOURTH_PHONE_CALLED',
  STALE_3_READY_FOR_OUTREACH = 'STALE_3_READY_FOR_OUTREACH',
  STALE_3_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_3_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_3_FIRST_PHONE_CALLED = 'STALE_3_FIRST_PHONE_CALLED',
  STALE_3_SECOND_PHONE_CALLED = 'STALE_3_SECOND_PHONE_CALLED',
  STALE_3_THIRD_PHONE_CALLED = 'STALE_3_THIRD_PHONE_CALLED',
  STALE_3_FOURTH_PHONE_CALLED = 'STALE_3_FOURTH_PHONE_CALLED',
  STALE_4_READY_FOR_OUTREACH = 'STALE_4_READY_FOR_OUTREACH',
  STALE_4_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_4_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_4_FIRST_PHONE_CALLED = 'STALE_4_FIRST_PHONE_CALLED',
  STALE_4_SECOND_PHONE_CALLED = 'STALE_4_SECOND_PHONE_CALLED',
  STALE_4_THIRD_PHONE_CALLED = 'STALE_4_THIRD_PHONE_CALLED',
  STALE_4_FOURTH_PHONE_CALLED = 'STALE_4_FOURTH_PHONE_CALLED',
  STALE_5_READY_FOR_OUTREACH = 'STALE_5_READY_FOR_OUTREACH',
  STALE_5_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_5_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_5_FIRST_PHONE_CALLED = 'STALE_5_FIRST_PHONE_CALLED',
  STALE_5_SECOND_PHONE_CALLED = 'STALE_5_SECOND_PHONE_CALLED',
  STALE_5_THIRD_PHONE_CALLED = 'STALE_5_THIRD_PHONE_CALLED',
  STALE_5_FOURTH_PHONE_CALLED = 'STALE_5_FOURTH_PHONE_CALLED',
  STALE_6_READY_FOR_OUTREACH = 'STALE_6_READY_FOR_OUTREACH',
  STALE_6_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_6_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_6_FIRST_PHONE_CALLED = 'STALE_6_FIRST_PHONE_CALLED',
  STALE_6_SECOND_PHONE_CALLED = 'STALE_6_SECOND_PHONE_CALLED',
  STALE_6_THIRD_PHONE_CALLED = 'STALE_6_THIRD_PHONE_CALLED',
  STALE_6_FOURTH_PHONE_CALLED = 'STALE_6_FOURTH_PHONE_CALLED',
  STALE_7_READY_FOR_OUTREACH = 'STALE_7_READY_FOR_OUTREACH',
  STALE_7_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_7_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_7_FIRST_PHONE_CALLED = 'STALE_7_FIRST_PHONE_CALLED',
  STALE_7_SECOND_PHONE_CALLED = 'STALE_7_SECOND_PHONE_CALLED',
  STALE_7_THIRD_PHONE_CALLED = 'STALE_7_THIRD_PHONE_CALLED',
  STALE_7_FOURTH_PHONE_CALLED = 'STALE_7_FOURTH_PHONE_CALLED',
  STALE_8_READY_FOR_OUTREACH = 'STALE_8_READY_FOR_OUTREACH',
  STALE_8_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_8_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_8_FIRST_PHONE_CALLED = 'STALE_8_FIRST_PHONE_CALLED',
  STALE_8_SECOND_PHONE_CALLED = 'STALE_8_SECOND_PHONE_CALLED',
  STALE_8_THIRD_PHONE_CALLED = 'STALE_8_THIRD_PHONE_CALLED',
  STALE_8_FOURTH_PHONE_CALLED = 'STALE_8_FOURTH_PHONE_CALLED',
  STALE_9_READY_FOR_OUTREACH = 'STALE_9_READY_FOR_OUTREACH',
  STALE_9_READY_FOR_FIRST_PHONE_QUEUED = 'STALE_9_READY_FOR_FIRST_PHONE_QUEUED',
  STALE_9_FIRST_PHONE_CALLED = 'STALE_9_FIRST_PHONE_CALLED',
  STALE_9_SECOND_PHONE_CALLED = 'STALE_9_SECOND_PHONE_CALLED',
  STALE_9_THIRD_PHONE_CALLED = 'STALE_9_THIRD_PHONE_CALLED',
  STALE_9_FOURTH_PHONE_CALLED = 'STALE_9_FOURTH_PHONE_CALLED',
}

// These are all possible time based states for ALL campaigns.
// If a campaign is not eligible for one of these states, we will not set the trickle multiplier
// and potential actions.
export type EligibleTimeBasedStateType =
  | PatientCampaignStateNameType.READY_FOR_OUTREACH
  | PatientCampaignStateNameType.READY_FOR_FIRST_PHONE_QUEUED
  | PatientCampaignStateNameType.EMAIL_SENT
  | PatientCampaignStateNameType.EMAIL_NOT_SENT
  | PatientCampaignStateNameType.SMS_SENT
  | PatientCampaignStateNameType.SMS_NOT_SENT
  | PatientCampaignStateNameType.PHONE_CALLED
  | PatientCampaignStateNameType.CALLBACK_PHONE_CALLED
  | PatientCampaignStateNameType.CALLBACK_PHONE_SCHEDULED;
